<template>
  <SecondaryBackground>
    <transition name="scale">
      <div v-if="!shouldShowSuccess" class="mt-5 sm:mt-16">
        <ForgotPassword @success="shouldShowSuccess = true"></ForgotPassword>
      </div>
    </transition>
    <div v-if="shouldShowSuccess" class="mt-5 sm:mt-16">
      <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 max-w-xl min-w-full sm:min-w-30 mx-auto">
        <h1 class="font-semibold text-2xl lg:text-3xl mb-12">
          Success
        </h1>
        <p class="leading-loose text-center mb-16">
          We've sent you a reset link
        </p>
        <div class="text-center">
          <router-link to="/auth/sign-in">
            <button
                type="button"
                class="btn btn-primary font-semibold rounded px-16"
            >
              Continue
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </SecondaryBackground>
</template>

<script>
  import ForgotPassword from "@/components/common/auth/ForgotPassword"
  import SecondaryBackground from "@/components/common/layout/SecondaryBackground"

  export default {
    components: {
      SecondaryBackground,
      ForgotPassword
    },
    data() {
      return {
        shouldShowSuccess: false
      }
    }
  }
</script>
